import React from "react";
import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { Logo } from "../Logo";
import { ThemeToggle } from "../ThemeToggle";

export const AuthLayout = ({ children, kicker, title, subtitle }) => (
  <div className="grid min-h-dvh bg-background lg:grid-cols-2">
    <div className="surface-1 relative hidden flex-col justify-between border-r border-border p-10 lg:flex">
      <div>
        <Logo size="h-8" to="/login" />
        <h2 className="mt-14 max-w-md text-3xl font-semibold leading-tight tracking-tight">
          A calm, precise view of your portfolio.
        </h2>
        <p className="mt-4 max-w-md text-sm leading-relaxed text-muted-foreground">
          Invextiing gives investors a single, verified source of truth for capital deployed, daily
          returns and withdrawal schedules. Figures are maintained by your relationship manager and
          are read-only for complete accuracy.
        </p>
        <ul className="mt-8 space-y-3 text-sm text-muted-foreground">
          {[
            "Daily profit and overall return tracking",
            "Verified investment and withdrawal ledgers",
            "Market updates direct from your manager",
          ].map((item) => (
            <li key={item} className="flex items-start gap-2.5">
              <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-primary" />
              {item}
            </li>
          ))}
        </ul>
      </div>
      <div className="flex items-center gap-2 text-xs text-muted-foreground">
        <ShieldCheck className="h-4 w-4 text-[hsl(var(--profit))]" />
        Secured by SSL · invextiing.com
      </div>
    </div>

    <div className="flex flex-col">
      <div className="flex items-center justify-between p-5 lg:justify-end">
        <span className="lg:hidden">
          <Logo size="h-7" to="/login" />
        </span>
        <ThemeToggle />
      </div>
      <div className="flex flex-1 items-center justify-center px-5 pb-10">
        <div className="w-full max-w-md">
          {kicker ? (
            <span className="mb-3 inline-flex items-center rounded-full border border-primary/30 bg-primary/10 px-2.5 py-0.5 text-xs font-medium text-primary">
              {kicker}
            </span>
          ) : null}
          <h1 className="text-2xl font-semibold tracking-tight">{title}</h1>
          {subtitle ? <p className="mt-2 text-sm text-muted-foreground">{subtitle}</p> : null}
          <div className="mt-7">{children}</div>
          <p className="mt-8 text-xs text-muted-foreground">
            <Link to="/privacy" className="underline-offset-4 hover:underline" data-testid="auth-privacy-link">
              Privacy Policy
            </Link>
            <span className="mx-2">·</span>
            <Link to="/terms" className="underline-offset-4 hover:underline" data-testid="auth-terms-link">
              Terms of Service
            </Link>
          </p>
        </div>
      </div>
    </div>
  </div>
);
